var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-box c-with-box-shadow"},[_c('div',{staticClass:"calendar-header"},[_vm._t("header")],2),_c('div',{staticClass:"calendar"},[_vm._t("calendar")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }